import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "@/context/AuthContext";
import { AuthShell, GoogleButton } from "@/pages/auth/AuthShell";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { apiErr } from "@/lib/api";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success(`${t("auth.login_title")}, ${u.first_name} !`);
      navigate(u.role === "admin" ? "/admin" : u.role === "manager" ? "/manager" : "/");
    } catch (err) { toast.error(apiErr(err)); } finally { setLoading(false); }
  };

  return (
    <AuthShell title={t("common.login")} subtitle={t("auth.login_sub")}>
      <form onSubmit={submit} className="space-y-3">
        <Input type="email" placeholder={t("auth.email")} value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="login-email" />
        <Input type="password" placeholder={t("auth.password")} value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="login-password" />
        <div className="text-right"><Link to="/forgot-password" className="text-xs text-primary hover:underline" data-testid="forgot-link">{t("auth.forgot")}</Link></div>
        <Button type="submit" disabled={loading} className="w-full h-11 font-semibold" data-testid="login-submit">
          {loading ? <Loader2 className="animate-spin" size={18} /> : t("auth.login_btn")}
        </Button>
      </form>
      <div className="flex items-center gap-3 my-4"><span className="flex-1 h-px bg-border" /><span className="text-xs text-muted-foreground">{t("auth.or")}</span><span className="flex-1 h-px bg-border" /></div>
      <GoogleButton />
      <p className="text-sm text-center text-muted-foreground mt-5">{t("auth.no_account")} <Link to="/register" className="text-primary font-semibold hover:underline" data-testid="goto-register">{t("auth.signup_link")}</Link></p>
    </AuthShell>
  );
}
